import React, { useRef, useState } from 'react';
import { Dialog, DialogActions, DialogContent, Slide } from "@mui/material";
import { GradientColorHeader } from "@Local/Components/Dialog";
import { Button, Divider, Grid, Typography } from '@curves/ui-base';

import { TagSection } from "@Local/Dashboard/Components";
import { v4 as uuid } from 'uuid';
import { groupBy, map } from "lodash";
const Transition = React.forwardRef((props, ref) => {
    return <Slide direction="left" ref={ref} {...props} />;
});
const AdvancedChartFilterTaggedDialog = (props) => {
    const { 
        open: openProps = false, 
        onClose: onCloseProps,
        onConfirm: onConfirmProps,
        options: optionProps = {},
        selected: selectedProps = [] 
    } = props;
    const defaultTagSection = groupBy(selectedProps, 'tagType');
    const [dialogKey, setDialogKey] = useState(uuid());
    const [clearKey, setClearKey] = useState(null);
    const sectionRef = useRef({});
    const { memberTagGroupOptions = [], orderTagGroupOptions = [] } = optionProps || {};
    const handleClickReset = () => {
        setClearKey('RESET');
        setDialogKey(uuid());
    };
    const handleClickClearAll = () => {
        setClearKey('ALL');
        setDialogKey(uuid());
    };
    const handleConfirm = () => {
        let result = [];
        memberTagGroupOptions.forEach((option) => {
            result = result.concat(sectionRef.current[option.tagType].getResult());
        });
        orderTagGroupOptions.forEach((option) => {
            result = result.concat(sectionRef.current[option.tagType].getResult());
        });
        onConfirmProps && onConfirmProps(result);
        onCloseProps && onCloseProps();
    };
    return (
        <Dialog open={openProps} TransitionComponent={Transition} fullScreen>
            <GradientColorHeader onClose={onCloseProps}>選擇搜尋標籤</GradientColorHeader>
            <DialogContent>
                <Grid container spacing={5}>
                    <Grid item xs={6}>
                        <Typography variant={'h3'} className={'text-center'}>會員標籤</Typography>
                        <Divider className="my-2" />
                        {memberTagGroupOptions && memberTagGroupOptions.map((option) => {
                            const { tagType, tagTypeText, tagOptions, targetType } = option;
                            const defaultSelected = clearKey === 'ALL' ? [] : map(defaultTagSection[tagType] || [], 'targetID');
                            return <TagSection key={`tag-section-${tagType}_${dialogKey}`}
                                               tagType={tagType}
                                               targetType={targetType}
                                               label={tagTypeText}
                                               tagOptions={tagOptions}
                                               defaultSelected={defaultSelected}
                                               ref={(el) => (sectionRef.current[tagType] = el)}
                            />;
                        })}
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant={'h3'} className={'text-center'}>購買項目標籤</Typography>
                        <Divider className="my-2" />
                        {orderTagGroupOptions && orderTagGroupOptions.map((option) => {
                            const { tagType, tagTypeText, tagOptions, targetType } = option;
                            const defaultSelected = clearKey === 'ALL' ? [] : map(defaultTagSection[tagType] || [], 'targetID');
                            return <TagSection key={`tag-section-${tagType}_${dialogKey}`}
                                               tagType={tagType}
                                               targetType={targetType}
                                               label={tagTypeText}
                                               tagOptions={tagOptions}
                                               defaultSelected={defaultSelected}
                                               ref={(el) => (sectionRef.current[tagType] = el)}
                            />;
                        })}
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={handleClickReset} color="primary">
                    重置選項
                </Button>
                <Button variant="outlined" onClick={handleClickClearAll} color="primary">
                    清除全部
                </Button>
                <Button variant="contained" color="primary" onClick={handleConfirm}>
                    確認
                </Button>
            </DialogActions>
        </Dialog>
    );
}
export default AdvancedChartFilterTaggedDialog;